import { createAction, props } from '@ngrx/store';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ICoordinateSystem } from '@app/api/interfaces/coordinate-system.interface';

export const loadCoordinateSystems = createAction('[CoordinateSystems] Load Coordinate Systems');

export const loadCoordinateSystemsSuccess = createAction(
  '[CoordinateSystems] Load Coordinate Systems Success',
  props<{ coordinateSystems: ICoordinateSystem[] }>()
);

export const coordinateSystemsFailure = createAction(
  '[CoordinateSystems] Load Failure',
  props<{ error: IApiBaseErrorResponse }>()
);
